export const ASSIGNMENT_TYPES = {
    ASSIGNMENT: { name: 'Assignment', value: 'n' },
    MODEL: { name: 'Model', value: 'm' },
    MODEL_BOUND_ASSIGNMENT: { name: 'Model bound assignment', value: 'a' },
}

export const ASSIGNMENT_TYPE_VALUE_TO_NAME = Object.values(ASSIGNMENT_TYPES).reduce((acc, type) => {
    acc[type.value] = type.name
    return acc
}, {})

export const getAssignmentTypeName = (value) => {
    return ASSIGNMENT_TYPE_VALUE_TO_NAME[value]
}